<div class="container">
    <p [ngClass]="businessLineBaseClassName+'-error-code'">{{errorCode}}</p>
    <p class="title">{{ "serverErrorComponent.title" | translate}}</p>
    <p>{{ "serverErrorComponent.message" | translate}}</p>
</div>